export const permissionAccountType = {
    LOAD_ACCOUNT_START : "LOAD_ACCOUNT_START",
    SET_ACCOUNT_SUCCESS : "SET_ACCOUNT_SUCCESS",
    SET_ACCOUNT_ERROR : "SET_ACCOUNT_ERROR",
    LOAD_WEIGHT_SLIP_START : "LOAD_WEIGHT_SLIP_START",
    SET_WEIGHT_SLIP_SUCCESS : "SET_WEIGHT_SLIP_SUCCESS",
    SET_WEIGHT_SLIP_ERROR : "SET_WEIGHT_SLIP_ERROR",
}
